const InvoiceArray_sample = [
  {
    orderData: {
      sot_id: "ORDER_ID",
      store_id: "STORE_ID",
      cmr_phone_number: "CUSTOMER_PHONE",
      sot_total_gst: "TOTAL_GST",
      sot_total_discount: "TOTAL_DISCOUNT",
      sot_payment_status: "PAYMENT_STATUS",
      sot_transaction_id: "TRANSACTION_ID",
      is_draft_order: "IS_DRAFT",
      sot_payment_method: "PAYMENT_METHOD",
      sot_billing_address: "BILLING_ADDRESS",
      sot_total_amount: "TOTAL_AMOUNT",
      sot_invoice_number: "INVOICE_NUMBER",
      doctor_name: "DOCTOR_NAME",
      cmr_first_name: "CUSTOMER_FIRST_NAME",
      cmr_last_name: "CUSTOMER_LAST_NAME",
      cmr_rewards: "CUSTOMER_REWARDS",
      created_date: "CREATED_DATE",
      update_date: "UPDATED_DATE",
      date: "DATE_TIMESTAMP",
      sot_return_status: "RETURN_STATUS",
      sot_remarks: "REMARKS",
      cmr_state: "CUSTOMER_STATE",
      cmr_pan: "CUSTOMER_PAN",
      cmr_area: "CUSTOMER_ADDRESS",
      cmr_gst: "CUSTOMER_GSTIN",
      cmr_company: "CUSTOMER_COMPANY",
      invoice_number: "INVOICE_NUMBER",
      sot_sub_total: "SUBTOTAL",
      round_off: "ROUND_OFF_VALUE"
    },
    itemData: [
      {
        item_id: "ITEM_ID",
        item_code: "ITEM_CODE",
        item_open_quantity: "OPEN_QUANTITY",
        item_generic_name: "GENERIC_NAME",
        item_name: "ITEM_NAME",
        item_pack_size: "PACK_SIZE",
        item_batch_number: "BATCH_NUMBER",
        item_quantity: "QUANTITY",
        item_exp_date: "EXPIRY_DATE",
        item_mfg_date: "MANUFACTURING_DATE",
        item_rack_location: "RACK_LOCATION",
        item_unit_price: "UNIT_PRICE",
        item_schedule: "SCHEDULE",
        item_discount_amount: "DISCOUNT_AMOUNT",
        item_discount_percentage: "DISCOUNT_PERCENTAGE",
        item_tax_amount: "TAX_AMOUNT",
        item_total_tax_percentage: "TOTAL_TAX_PERCENTAGE",
        item_total_amount: "TOTAL_AMOUNT",
        item_price_wiithout_tax: "PRICE_WITHOUT_TAX",
        item_gst: "GST",
        item_sgst: "SGST",
        item_cgst: "CGST",
        item_igst: "IGST",
        item_uom: "UOM",
        total_sellable_quantity: "SELLABLE_QUANTITY",
        item_total_qaunitiy: "TOTAL_QUANTITY",
        item_free_quantity: "FREE_QUANTITY",
        item_manufacturer_id: "MANUFACTURER_ID",
        item_manufacturer_name: "MANUFACTURER_NAME",
        item_mfg: "MANUFACTURER",
        item_hsn: "HSN_CODE"
      },
    ],
    paymentData: [
      {
        payment_mode_name: "PAYMENT_MODE",
        payment_amount: "PAYMENT_AMOUNT"
      },
    ]
  },
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {InvoiceArray_sample,storeDetailsResult_sample};